import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {Params, RouterModule} from '@angular/router';

export type BreadcrumbRoute = string | any[];

export interface BreadcrumbItem {
  label: string;
  route?: BreadcrumbRoute;
  queryParams?: Params;
  fragment?: string;
}

@Component({
  selector: 'app-breadcrumbs',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent {
  @Input({required: true}) items: BreadcrumbItem[] = [];
}
